<template>
  <div>
    <transactions
      :transaction-class="transactionClass"
      :verbose-name="JSON.parse($route.params.sales) ? 'Bon de livraison' : 'Livraison'"
      :verbose-name-plural="JSON.parse($route.params.sales) ? 'Bons de livraison' : 'Livraisons'"
      ressource="delivery-notes"
      :add="false"
      :colors="colors"
    ></transactions>
  </div>
</template>

<script>
import { Hk } from '@/node-sdk'

import Transactions from '@/router/view/commercial/components/transactions'

const { DeliveryNote } = Hk.Crm
export default {
  name: 'delivery-notes',

  components: {
    Transactions,
  },

  data() {
    return {
      transactionClass: null,
      colors: DeliveryNote.get_colors(),
    }
  },

  mounted() {
    this.transactionClass = DeliveryNote
  },
}
</script>

<style></style>
